import { IStatsDesktopResponseSchema } from '../../repositories/newbuilding-card/entities/stats/StatsDesktopResponseSchema';
import { TApplicationState } from '../../types/redux';

export function getOffers(state: TApplicationState) {
  return state.offers.data.total || ({} as IStatsDesktopResponseSchema);
}

export function getSelectedHouseOffers(state: TApplicationState) {
  const houseId = state.offers.selectedHouseId || 'total';

  return state.offers.data[houseId];
}
